module.exports = __webpack_public_path__ + "static/media/data-not-found.0a736be1.svg";